import { BaseApiClient } from '../../../lib/api/BaseApiClient';
import { buildFingerprint } from '../../../lib/device/fingerprint';

// Maps to the "Login" folder of the CC_Customer Postman collection.
class AuthApi extends BaseApiClient {
  constructor() { super('Login'); }

  // GET /Login/Status — public (headersWithoutToken)
  status() {
    return this.get('/Status', { headers: { Accept: 'text/plain' }, skipAuth: true });
  }

  // POST /Login/GenerateOTP — public (headersWithoutToken)
  generateOTP({ mobile, name = '', email = '' }) {
    return this.post('/GenerateOTP', {
      name, mobile, email, otpCode: '', autoFillKey: '', fingerprint: buildFingerprint(),
    }, { skipAuth: true });
  }

  // POST /Login/ValidateOTP — public (headersWithoutToken); returns full
  // envelope (token lives alongside result).
  validateOTP({ mobile, otpCode, name = '', email = '' }) {
    return this.raw('post', '/ValidateOTP', {
      name, mobile, email, otpCode, autoFillKey: '', fingerprint: buildFingerprint(),
    }, { skipAuth: true });
  }

  // POST /Login/Logout — authenticated (headersAPI)
  logout() {
    return this.post('/Logout');
  }

  // POST /Login/ContactUs — public (headersWithoutToken)
  contactUs({ name, email, mobile, message }) {
    return this.post('/ContactUs', { name, email, mobile, message }, { skipAuth: true });
  }
}

export const authApi = new AuthApi();

// Backwards-compatible named exports (LoginModal still imports these)
export const checkStatus = () => authApi.status();
export const generateOTP = (args) => authApi.generateOTP(args);
export const validateOTP = (args) => authApi.validateOTP(args);
